import { DatePipe } from "@angular/common"
import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core"
import { BsModalService } from "ngx-bootstrap/modal"
import { AppState, RoleMgr, ShowRequest } from "../../../../core"
import { ScoutPath, ScoutPoint } from "../../../../core/models"
import { BuildingService, ScoutTaskService } from "../../../../core/services"
import { TableColumn } from "../../../../shared/components/table-view/table-view-component-base"
import { ScoutDataTableBase } from "../scout-data-table/scout-data-table-base"

class PathPoint {
  buildingId : string
  pathName : string  
  pathDescription : string
  toName : string
  fromName : string
  type : string
  pointId : string
  latitude : string
  longitude : string
  floor : string

  // stuff these values to each record so we can display them on double clicks
  path : ScoutPath
  point : ScoutPoint
}


@Component({
    selector: 'app-scout-path-points-table',
    templateUrl: 'path-points-table.component.html',
    styleUrls: [
      '../../../../shared/components/table-view/scss/table-view.scss',
      '../scout-data-table/scout-data-table.scss'
    ]
  })
  export class ScoutPathPointsTableComponent extends ScoutDataTableBase<PathPoint> implements OnInit, OnDestroy {
    
    wordWrapDescription = true

    constructor(
        appState: AppState,
        elementRef: ElementRef,
        datePipe: DatePipe,
        bsModalService: BsModalService,
        roleMgr: RoleMgr,
        public scoutTaskService: ScoutTaskService,
        public buildingService: BuildingService
    ){
      super(appState,elementRef,datePipe,roleMgr,bsModalService)
  
      const initColumnDef = (col: any,i:number) => {
        col.visible = col.visible !== false
        col.headerCellCssClass = [ col.headerCellCssClass ].filter(cssName=>cssName).join(' ')
        col.dataCellCssClass = [ col.dataCellCssClass ].filter(cssName=>cssName).join(' ')
        if ( !col.template ) {
          col.template = 'text'
        }
        return col as TableColumn
      }
      
      this.tableColumns  = [
        { title: 'Building ID', name: 'buildingId'},
        { title: 'Path', name: 'pathName'},
        { title: 'Path Description', name: 'pathDescription', dataCellCssClass: 'text-left', template: 'empty'},
        { title: 'To', name: 'toName', template: 'scoutPointBtn'},
        { title: 'From', name: 'fromName', template: 'scoutPointBtn'},
        { title: 'Type', name: 'type', template: 'type'},
        { title: 'Point ID', name: 'pointId', dataCellCssClass: 'text-left'},
        { title: 'Latitude', name: 'latitude'},
        { title: 'Longitude', name: 'longitude'},
        { title: 'Floor', name: 'floor', visible: false},  
        { title: 'Point Description', name: 'pointDescription', dataCellCssClass: 'text-left', visible: false},
      ].map((col,index)=> initColumnDef(col,index))

      this.onScoutPointModalChange = ( pt:ScoutPoint ) => {
        this.selectedRecord = this.records?.find(rec=>rec.point.id==pt?.id) 
      }
    }  


    ngOnInit(): void {
      this.init()
    }
  

    ngOnDestroy(): void {
      this.destroy()
    }


    onDataCellDblClick( column : TableColumn, record : PathPoint ) {
      this.selectedRecord = record
      if ( ['buildingId'].includes(column.name) ) {
        this.showTabFn( new ShowRequest('tab','building',record.buildingId) )
      } else if ( ['pathName', 'pathDescription','floor'].includes(column.name) ) {
        this.showTabFn( new ShowRequest('tab','scout path',record.path.id,this._scoutTaskDoc) )
      } else {
        this.showScoutPoint( record.path, record.point )
      }
    }


    async processQueryResults(queryResults: any[]) {
      let records = []
      const buildingId = this._scoutTaskDoc.buildingId
      for( let i = 0; i < queryResults?.length; i++ ) {        
        const path = queryResults[i];
        //if ( this.pathIds?.length && !this.pathIds.includes(path.id) ) {
        //  continue
        //}
        const pathName = path.pathNumber ? buildingId + 'P' + `${path.pathNumber}`.padStart(2,'0') : ''
        let buildingPoints = [] // [this.startPoint] //for plotter without edit mode enabled, just need HA start point info
        this.scoutTaskService.updateScoutPathContext(path,buildingPoints)
        for( let pointIndex = 0; pointIndex < path.scoutPoints?.length; pointIndex++ ) {
          const pt = path.scoutPoints[pointIndex];
          
          let pointId : string
          if ( pt.type != 'VIA') {
            if ( pt.type == 'HA' && pt.pointId ) {
              pointId = pt.pointId;
            } else {
              pointId = pt.exPointId
            }
          }
          const fromPoint = pt.parentId ? path.scoutPoints.find(sp=>sp.id==pt.parentId) : null
          //const fromPointId = fromPoint ? fromPoint.pointId || fromPoint.exPointId : null

          //console.log(JSON.stringify(pt))
          const record = {
            buildingId,
            pathName,
            pathDescription : path.description,
            toName : pt.name,
            fromName : fromPoint?.name,
            type : pt.type,
            pointId,
            latitude : pt.latitude?.toFixed(7),
            longitude : pt.longitude?.toFixed(7),
            floor : path.floor,
            path : path,
            point : pt
          }
          if ( this.applyLocalFilter( record ) ) {
            records.push( record )
          }
        }
      }
      return records
    }
  

    getName = () => 'path-points'
  
  }